import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTHeadCell } from '@celebration/design-system/dist/lib/table-thead-cell';

export default createComponent({
    react: React,
    elementClass: ClbTableTHeadCell,
    tagName: ClbTableTHeadCell.tagName,
    events: ClbTableTHeadCell.events,
});

export const TableTHeadCellSlots = ClbTableTHeadCell.slots;
